/**
 * Homepage: fade sections in when ~18% visible. No scroll listeners.
 * Skips first MainContent section (hero) so above-the-fold is never faded on load.
 */
(function () {
  if (!document.body.classList.contains('template--index')) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  var sections = main.querySelectorAll(':scope > .shopify-section');
  if (sections.length < 2) return;

  var REVEAL_CLASS = 'home-reveal-section';
  var VISIBLE_CLASS = 'home-reveal-section--visible';
  var THRESHOLD = 0.4;

  // Exclude the first above-the-fold hero from fading on load.
  // Prefer the known hero section id; fall back to skipping the first child.
  var HERO_SECTION_ID = 'shopify-section-home_hero_split';

  var heroFound = false;
  var observedSections = [];

  for (var j = 0; j < sections.length; j++) {
    var section = sections[j];
    var isHero = section.id === HERO_SECTION_ID;
    if (isHero) heroFound = true;

    if (isHero) continue;
    if (!heroFound && j === 0) continue; // fallback

    // Add the slightly-faded state to sections that are fully below the fold
    // on initial page load. Also apply it to near-the-fold sections that are
    // already partially visible, but not yet at the reveal threshold.
    var rect = section.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var sectionHeight = rect.height || (rect.bottom - rect.top) || 0;
    var visibleTop = Math.max(rect.top, 0);
    var visibleBottom = Math.min(rect.bottom, viewportHeight);
    var visibleHeight = Math.max(0, visibleBottom - visibleTop);
    var initialRatio = sectionHeight > 0 ? visibleHeight / sectionHeight : 0;

    // If a section is not yet prominently visible (below the reveal ratio),
    // start it slightly faded so the transition can be perceived.
    if (initialRatio < THRESHOLD) section.classList.add(REVEAL_CLASS);

    observedSections.push(section);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (entry.intersectionRatio < THRESHOLD) return;

        entry.target.classList.add(VISIBLE_CLASS);
        // Keep the faded class for the CSS transition to run.
        observer.unobserve(entry.target); // one-time reveal
      });
    },
    { threshold: THRESHOLD }
  );

  for (var k = 0; k < observedSections.length; k++) {
    observer.observe(observedSections[k]);
  }
})();
